// extracted by mini-css-extract-plugin
export default {"root":"Location-root-cde8"};